import { DownloadOutlined, DeleteOutlined, HistoryOutlined } from '@ant-design/icons';
import styled from 'styled-components';

// svgs
import { ReactComponent as IconArrowDown } from '../../images/keyboard_arrow_down.svg';

// components, keys, and utils
import { ActionAbleItems } from '../shared/bulkAction/BulkAction';
import { ANTD_GRAY } from '../entity/shared/constants';
import { ModalKeys } from './BrowseDataProductModalKeys';

const DownArrow = styled(IconArrowDown)`
    && {
        margin-left: 4px;
        width: 20px !important;
        height: 20px !important;
        color: ${ANTD_GRAY[10]};
    }
`;

/**
 * Generates a list of actionable items for bulk actions in the Browse Data Product feature.
 * Each action item can trigger a modal or perform a specific operation.
 *
 * @param openModal - A function that takes a modal key as a string and opens the corresponding modal.
 * @returns An array of `ActionAbleItems` objects, each representing a bulk action.
 *
 * The returned array contains the following actions:
 * - **Update**: A parent action with a dropdown containing sub-actions:
 *   - **Update Domain**: Opens the modal for updating the domain.
 *   - **Update Owners**: Opens the modal for updating the owners.
 *   - **Update Tags**: Opens the modal for updating the tags.
 *   - **Update Terms**: Opens the modal for updating the terms.
 *   - Includes a suffix icon (down arrow) for the dropdown.
 * - **Delete**: Triggers the delete modal.
 *
 * Each action includes optional icons for visual representation.
 */
export const BrowseDataProductBulkActionAbleItems = (
    openModal: (key: string) => void,
    exportXlsx: () => void,
): ActionAbleItems[] => [
    {
        key: 'update',
        name: 'Update',
        onClick: () => {},
        prefixIcon: HistoryOutlined,
        dropDownActionAbleItems: [
            {
                key: 'updateDomain',
                name: 'Update Domain',
                onClick: () => {
                    openModal(ModalKeys.UPDATE_DOMAIN);
                },
            },
            {
                key: 'updateOwners',
                name: 'Update Owners',
                onClick: () => {
                    openModal(ModalKeys.UPDATE_OWNERS);
                },
            },
            {
                key: 'updateTags',
                name: 'Update Tags',
                onClick: () => {
                    openModal(ModalKeys.UPDATE_TAGS);
                },
            },
            {
                key: 'updateTerms',
                name: 'Update Terms',
                onClick: () => {
                    openModal(ModalKeys.UPDATE_TERMS);
                },
            },
        ],
        suffixIcon: DownArrow,
    },
    {
        key: 'export',
        name: 'Export',
        onClick: exportXlsx,
        prefixIcon: DownloadOutlined,
    },
    {
        key: 'delete',
        name: 'Delete',
        onClick: () => {
            openModal(ModalKeys.DELETE);
        },
        prefixIcon: DeleteOutlined,
    },
];
